export interface KeyEvent {
  name: string;
  location: string;
  cat: string;
  start: string;
  end: string;
  status: "confirmed" | "expected" | "tbc";
}

export const KEY_EVENTS_MONTHS = [
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan '27",
  "Feb",
  "Mar",
  "Apr '27",
];

export const KEY_EVENTS_START = new Date(2026, 3, 1);
export const KEY_EVENTS_END = new Date(2027, 4, 1);

export const KEY_EVENTS: KeyEvent[] = [
  {
    name: "Maldives Referendum on Merging Elections",
    location: "Maldives, 1 April 2026",
    cat: "election",
    start: "2026-04-01",
    end: "2026-04-01",
    status: "confirmed",
  },
  {
    name: "OPEC+ Joint Ministerial Monitoring Committee (JMMC) — 65th Meeting",
    location: "",
    cat: "economic",
    start: "2026-04-03",
    end: "2026-04-03",
    status: "confirmed",
  },
  {
    name: "Djibouti Presidential Election",
    location: "",
    cat: "election",
    start: "2026-04-10",
    end: "2026-04-10",
    status: "confirmed",
  },
  {
    name: "Hungary — National Parliamentary Elections",
    location: "",
    cat: "election",
    start: "2026-04-12",
    end: "2026-04-12",
    status: "confirmed",
  },
  {
    name: "Benin — Presidential Election",
    location: "",
    cat: "election",
    start: "2026-04-12",
    end: "2026-04-12",
    status: "confirmed",
  },
  {
    name: "Peru — Presidential and Legislative Elections (First Round)",
    location: "",
    cat: "election",
    start: "2026-04-13",
    end: "2026-04-13",
    status: "confirmed",
  },
  {
    name: "IMF/World Bank Spring Meetings 2026",
    location: "United States, 10–14 April 2026",
    cat: "economic",
    start: "2026-04-10",
    end: "2026-04-14",
    status: "confirmed",
  },
  {
    name: "G20 Finance Ministers and Central Bank Governors Meeting (Washington)",
    location: "United States, ~14 April 2026",
    cat: "summit",
    start: "2026-04-14",
    end: "2026-04-15",
    status: "confirmed",
  },
  {
    name: "Bulgaria — Parliamentary Elections",
    location: "Bulgaria, ~19 April 2026",
    cat: "election",
    start: "2026-04-19",
    end: "2026-04-19",
    status: "confirmed",
  },
  {
    name: "Petersberg Climate Dialogue",
    location: "Germany, 20–22 May 2026",
    cat: "climate",
    start: "2026-05-20",
    end: "2026-05-22",
    status: "confirmed",
  },
  {
    name: "Deep Sea Mining Summit 2026",
    location: "United Kingdom, 25–26 April 2026",
    cat: "industry",
    start: "2026-04-25",
    end: "2026-04-26",
    status: "confirmed",
  },
  {
    name: "EU Leaders Summit",
    location: "Cyprus, 20–24 April 2026",
    cat: "summit",
    start: "2026-04-20",
    end: "2026-04-24",
    status: "confirmed",
  },
  {
    name: "International Conference on the Just Transition Away from Fossil Fuels",
    location: "Colombia, 24–25 April 2026",
    cat: "climate",
    start: "2026-04-24",
    end: "2026-04-25",
    status: "confirmed",
  },
  {
    name: "Three Seas Initiative Summit",
    location: "Sweden, 24–25 April 2026",
    cat: "summit",
    start: "2026-04-24",
    end: "2026-04-25",
    status: "confirmed",
  },
  {
    name: "US Federal Reserve — FOMC Rate Decision (April)",
    location: "",
    cat: "economic",
    start: "2026-04-29",
    end: "2026-04-29",
    status: "confirmed",
  },
  {
    name: "India State Elections — Tamil Nadu, West Bengal (Second Round)",
    location: "India",
    cat: "election",
    start: "2026-05-01",
    end: "2026-05-01",
    status: "expected",
  },
  {
    name: "46th ASEAN Leaders' Summit",
    location: "Philippines, 6–9 May 2026",
    cat: "summit",
    start: "2026-05-06",
    end: "2026-05-09",
    status: "confirmed",
  },
  {
    name: "Colombia — Presidential Election (First Round)",
    location: "Colombia, 31 May 2026",
    cat: "election",
    start: "2026-05-31",
    end: "2026-05-31",
    status: "confirmed",
  },
  {
    name: "Peru — Presidential Election Runoff (if required) *",
    location: "Peru, ~1 June 2026",
    cat: "election",
    start: "2026-06-01",
    end: "2026-06-01",
    status: "expected",
  },
  {
    name: "OPEC+ 41st Ministerial Meeting",
    location: "",
    cat: "economic",
    start: "2026-06-07",
    end: "2026-06-07",
    status: "confirmed",
  },
  {
    name: "52nd G7 Leaders Summit",
    location: "Canada, 21 June 2026",
    cat: "summit",
    start: "2026-06-20",
    end: "2026-06-22",
    status: "confirmed",
  },
  {
    name: "Colombia — Presidential Election Runoff (if required) *",
    location: "Colombia, ~June 2026",
    cat: "election",
    start: "2026-06-21",
    end: "2026-06-21",
    status: "expected",
  },
  {
    name: "2026 Ankara NATO Summit",
    location: "Turkey, 7–9 July 2026",
    cat: "summit",
    start: "2026-07-07",
    end: "2026-07-09",
    status: "confirmed",
  },
  {
    name: "SCO Heads of State Summit — Bishkek *",
    location: "Philippines, ~July 2026",
    cat: "summit",
    start: "2026-07-15",
    end: "2026-07-16",
    status: "expected",
  },
  {
    name: "G20 Finance Ministers and Central Bank Governors Meeting (scheduled)",
    location: "United States, 31 August – 1 September 2026",
    cat: "summit",
    start: "2026-08-31",
    end: "2026-09-01",
    status: "confirmed",
  },
  {
    name: "81st UN General Assembly — Opening",
    location: "",
    cat: "summit",
    start: "2026-09-15",
    end: "2026-09-15",
    status: "confirmed",
  },
  {
    name: "2026 BRICS Summit — New Delhi",
    location: "",
    cat: "summit",
    start: "2026-09-17",
    end: "2026-09-19",
    status: "expected",
  },
  {
    name: "UNGA 81 — High-Level General Debate",
    location: "United States, 24–28 September 2026",
    cat: "summit",
    start: "2026-09-24",
    end: "2026-09-28",
    status: "confirmed",
  },
  {
    name: "Brazil — General Elections (First Round)",
    location: "Brazil, 4 October 2026",
    cat: "election",
    start: "2026-10-04",
    end: "2026-10-04",
    status: "confirmed",
  },
  {
    name: "IMF/World Bank Annual Meetings 2026 — Bangkok",
    location: "Thailand, 12–18 October 2026",
    cat: "economic",
    start: "2026-10-12",
    end: "2026-10-18",
    status: "confirmed",
  },
  {
    name: "G20 Finance Ministers Meeting (Bangkok, Jakarta)",
    location: "Thailand, 18 October 2026",
    cat: "summit",
    start: "2026-10-18",
    end: "2026-10-19",
    status: "confirmed",
  },
  {
    name: "G20 Heads 2026 — London",
    location: "",
    cat: "summit",
    start: "2026-10-25",
    end: "2026-10-26",
    status: "expected",
  },
  {
    name: "Brazil — General Elections Runoff (if required) *",
    location: "Brazil, 30 October 2026",
    cat: "election",
    start: "2026-10-30",
    end: "2026-10-30",
    status: "expected",
  },
  {
    name: "United States — Midterm Elections",
    location: "United States, 3 November 2026",
    cat: "election",
    start: "2026-11-03",
    end: "2026-11-03",
    status: "confirmed",
  },
  {
    name: "COP31 — UN Climate Change Conference (Antalya)",
    location: "Turkey, 9–20 November 2026",
    cat: "climate",
    start: "2026-11-09",
    end: "2026-11-20",
    status: "confirmed",
  },
  {
    name: "44th ASEAN Summit and Related Summits *",
    location: "Philippines, ~November 2026",
    cat: "summit",
    start: "2026-11-14",
    end: "2026-11-16",
    status: "expected",
  },
  {
    name: "APEC Economic Leaders' Meeting — Shenzhen",
    location: "",
    cat: "summit",
    start: "2026-11-20",
    end: "2026-11-22",
    status: "confirmed",
  },
  {
    name: "London Mining Week / Resourcing Tomorrow",
    location: "United Kingdom, 30 November – 4 December 2026",
    cat: "industry",
    start: "2026-11-30",
    end: "2026-12-04",
    status: "confirmed",
  },
  {
    name: "2026 G20 Multi Leaders' Summit",
    location: "",
    cat: "summit",
    start: "2026-12-10",
    end: "2026-12-13",
    status: "expected",
  },
  {
    name: "Future Minerals Forum 2027 — Riyadh",
    location: "Saudi Arabia, 13–15 January 2027",
    cat: "industry",
    start: "2027-01-13",
    end: "2027-01-15",
    status: "confirmed",
  },
  {
    name: "Mining Indaba 2027 — Cape Town",
    location: "South Africa, 9–12 February 2027",
    cat: "industry",
    start: "2027-02-09",
    end: "2027-02-12",
    status: "confirmed",
  },
  {
    name: "PDAC 2027 — Toronto",
    location: "Canada, ~March 2027",
    cat: "industry",
    start: "2027-03-08",
    end: "2027-03-11",
    status: "confirmed",
  },
];
